import { render, staticRenderFns } from "./TrocarAnalista.vue?vue&type=template&id=6530a5df&lang=pug&"
import script from "./TrocarAnalista.vue?vue&type=script&lang=js&"
export * from "./TrocarAnalista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports